export class TicketTypeInput {
    public name: string='';
}
